import {
   createApp
} from 'vue';


const app = createApp({
   data() {
      return {
         loading: false,
         nextPage: 0,
         items: [],
         selectedYear: null,
         selectedCat: null,
         selectedFilters: [],

      };
   },
   mounted() {
      this.loadPosts();
      window.addEventListener('scroll', this.handleScroll);
   },

   methods: {

      loadPosts(append = false) {
         if (this.loading) {
            return;
         }

         this.loading = true;

         const params = {};
         
         if (this.selectedYear) {
            params['year'] = this.selectedYear;
         }
         if (this.nextPage) {
            params['page'] = this.nextPage;
         }

         if(this.selectedCat) {
            params['categoria'] = this.selectedCat;
         }

         const filters = new URLSearchParams(params).toString();

         var request = new XMLHttpRequest();
         request.open('GET', `/wp-json/wexa/v2/articoli?${filters}`, true);
         request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      
         request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
               const response = JSON.parse(request.responseText);

               if (append) {
                  this.items = this.items.concat(response.data);
               } else {
                  this.items = response.data;
               }

      
               this.nextPage = response.next_page;
            } else {
               this.items = [];
            }
            this.loading = false;
         };
      
         request.onerror = () => {
            this.items = [];
            this.loading = false;
         };
      
         request.send('action=postsIndex');
      },

      handleScroll() {
         const scrollY = window.scrollY;
         const windowHeight = window.innerHeight;
         const documentHeight = document.documentElement.scrollHeight;
         const hfooter = window.innerWidth <= 768 ? 1200 : 420;

         if (scrollY + windowHeight >= documentHeight - hfooter) {
           if (this.nextPage !== null) {
              this.loadPosts(true);
           }
         }
         
      },

      filterCategory(cat) {
         this.selectedFilters = []
         if (cat === this.selectedCat) {
            this.selectedCat = null;
            this.nextPage = 0;
         } else {
            this.selectedCat = cat;
            this.nextPage = 0;
            this.selectedFilters.push(cat)
         }

         this.loadPosts();
      },

      isFilterActive(type, value) {
         return this.selectedFilters.some(filter => filter.type === type && filter.value === value);
      },

      filterByYear(year) {
         this.selectedFilters = []
         if (year === this.selectedYear) {
            this.selectedYear = null;
            this.nextPage = 0;
         } else {
            this.selectedYear = year;
            this.nextPage = 0;
            this.selectedFilters.push(year)
         }

         this.loadPosts();
      },

   }
});

const archive = document.getElementById('archive-news');
if(archive) {
   app.mount('#archive-news');
}
